<template>
  <div>
    <div class="fixBg">
      <div class="pxindBox">
        <div v-if="this.$root.$data.isApp">
          <img class="pxind" src="@/assets/img/loginImg/remind.png" alt="">
          <p class="posBtn"
             v-clipboard:copy="'qihangjiaoyu-6'"
             v-clipboard:success="onCopy"
             v-clipboard:error="onError"
          >&nbsp;</p>
        </div>
        <div v-else class="h5-official-account">
          <img class="pxind" src="https://image-prod.iqihang.com/project/ark-student-pc/img/remind.2db6f856.png" alt="">
          <img class="qrcode" src="https://image-prod.iqihang.com/project/ark-student-pc/img/remind-code.8173023b.png" />
          <p>截图扫码关注公众号</p>
        </div>
        <img @click="closeRemindBox" class="closepxind" src="@/assets/img/loginImg/closeRemind.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  components: {
  },

  created() {},

  mounted() {},
  activated() {},
  methods: {
    closeRemindBox() {
      this.$emit('closeRemindBox');
    },
    onCopy() {
      // 跳转微信
      this.$toast({
        message: '服务号已复制成功',
        position: 'middle',
        duration: 2000,
      });
      this.$sendToApp('addWechat', {
        WechatNum: 'qihangjiaoyu',
      });
    },
    onError() {
      this.$toast({
        message: '复制失败',
        position: 'middle',
        duration: 2000,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.fixBg{
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 20000;
  width: 100%;
  height: 100%;
  background:rgba(0,0,0,.3) ;
}
.pxindBox{
  position: absolute;
  top: 22%;
  right: 0;
  left: 0;
  width: 543px;
  margin: 0 auto;
}
.h5-official-account {
  padding-bottom: 32px;
  text-align: center;
  background: #fff;
  .qrcode {
    width: 40%;
    margin-top: 20px;
    margin-bottom: 16px;
  }
  p {
    color: #787878;
    font-size: 24px;
  }
}
.pxind{
  width: 100%;
}
.posBtn{
  position: absolute;
  top: 530px;
  right: 0;
  left: 0;
  width: 420px;
  height: 80px;
  margin: 0 auto;
  border-radius: 40px;
}
.closepxind{
  position: absolute;
  right: 0;
  bottom: -100px;
  left: 0;
  width: 58px;
  height: 58px;
  margin: 0 auto;

}

</style>
